var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.isLoaderVisible
      ? _c("div", { staticClass: "loader" }, [
          _c(
            "div",
            { staticClass: "sdl-center wd-3", staticStyle: { width: "610px" } },
            [
              _c("div", { staticClass: "msg-box" }, [
                _c("div", { staticClass: "msg-icon" }, [
                  _c("em", {
                    staticClass: "icon-info text-warning icon-size-2"
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "msg-text" }, [
                  _c("h3", { staticClass: "mb-4" }, [
                    _vm._v("Information Message")
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticClass: "d-block mb-3" }, [
                    _vm._v(_vm._s(_vm.$t("sdl.common.message.initLoadingMsg")))
                  ]),
                  _vm._v(" "),
                  _c("ol", { staticClass: "list-unstyled" }, [
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("sdl.common.message.browserInfo1")))
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("sdl.common.message.browserInfo2")))
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("sdl.common.message.browserInfo3")))
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("sdl.common.message.browserInfo4")))
                    ])
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("footer", { staticClass: "ui--footer-container" }, [
            _c("div", { staticClass: "ui--footer-in" }, [
              _c("span", [_vm._v("© Samsung")])
            ])
          ])
        ])
      : _vm.errorState.code !== "196"
      ? _c("div", { staticStyle: { width: "100%" } }, [
          _vm.lnbHideValue
            ? _c("div", [
                _c(
                  "form",
                  {
                    staticClass: "ui--form-login",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSubmit.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("header", { staticClass: "mb-4" }, [
                      _c("img", {
                        staticClass: "mb-3 ui--brand-simbol",
                        attrs: {
                          src: _vm.$CONTEXT + "/static/image/main/simbol.png",
                          alt: "System Simbol"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "brand-text" }, [
                        _vm._v(_vm._s(_vm.title))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "sr-only", attrs: { for: "inputID" } },
                      [_vm._v("ID")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userId,
                          expression: "userId"
                        }
                      ],
                      staticClass: "form-control ui--login-id",
                      attrs: {
                        type: "text",
                        id: "inputID",
                        placeholder: "ID",
                        required: "",
                        autofocus: ""
                      },
                      domProps: { value: _vm.userId },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.userId = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        staticClass: "sr-only",
                        attrs: { for: "inputPassword" }
                      },
                      [_vm._v("Password ")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control ui--login-pass",
                      staticStyle: { display: "none" },
                      attrs: {
                        type: "password",
                        id: "inputPassword",
                        placeholder: "Password",
                        required: ""
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox mb-3" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rememberMe,
                              expression: "rememberMe"
                            }
                          ],
                          staticStyle: { display: "none" },
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.rememberMe)
                              ? _vm._i(_vm.rememberMe, null) > -1
                              : _vm.rememberMe
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.rememberMe,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.rememberMe = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.rememberMe = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.rememberMe = $$c
                              }
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-lg btn-primary btn-block",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.handleSubmit()
                          }
                        }
                      },
                      [_vm._v("Login")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-outline-secondary btn-block",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.loginByAd()
                          }
                        }
                      },
                      [_vm._v("\n          AD SSO Login\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-outline-secondary btn-block",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.loginByNewEpTray()
                          }
                        }
                      },
                      [_vm._v("\n          New EpTray Login\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "mt-3" },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: _vm.$CONTEXT + "/register" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("sdl.common.label.membership"))
                            )
                          ]
                        ),
                        _vm._v("  |  "),
                        _c(
                          "router-link",
                          { attrs: { to: _vm.$CONTEXT + "/initPassword" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("sdl.common.label.initPassword")
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e()
        ])
      : _c("div", { staticClass: "ui--form-login login-info" }, [
          _c("header", { staticClass: "mb-4" }, [
            _c("img", {
              staticClass: "mb-3 ui--brand-simbol",
              attrs: {
                src: _vm.$CONTEXT + "/static/image/main/simbol.png",
                alt: "System Simbol"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "brand-text" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "mb-4" }),
          _vm._v(" "),
          _c("div", { staticClass: "message" }, [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("sdl.common.label.selectRole"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "file-list bg-white mb-3" }, [
              _c(
                "ul",
                _vm._l(_vm.roleList, function(role, index) {
                  return _c("li", { key: index }, [
                    _c("div", { staticClass: "form-check text-left" }, [
                      _c("label", { staticClass: "form-check-label" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: role.selected,
                              expression: "role.selected"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(role.selected)
                              ? _vm._i(role.selected, null) > -1
                              : role.selected
                          },
                          on: {
                            change: function($event) {
                              var $$a = role.selected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      role,
                                      "selected",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      role,
                                      "selected",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(role, "selected", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" " + _vm._s(role.roleName))
                      ])
                    ])
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-lg btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.signonReg }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("sdl.identity.label.userRegistration")) +
                  "\n    "
              )
            ]
          )
        ]),
    _vm._v(" "),
    _vm.lnbHideValue
      ? _c("div", [
          !_vm.isLoaderVisible
            ? _c("footer", { staticClass: "ui--footer-container" }, [
                _c("p", { staticClass: "text-muted" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("sdl.common.message.onlyAuthUserLegalSanctions")
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("© Samsung")])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ccf4aac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ccf4aac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/LoginPage.vue
// module id = null
// module chunks = 